import React, { useState, useImperativeHandle } from 'react';
function MultiSelect( { label, defaultValue, gridWidth, icon, options, name , onChange , visible } , ref ) {
    const containerClass = [
        'multiselect',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();

    const initialSelected = [];
    if ( defaultValue !== null && defaultValue !== '' ) {
        const values = defaultValue.split(',');
        for ( let i = 0; i < values.length; i++ ) {
            const val = values[i].trim();

            for ( let j = 0; j < options.length; j++ ) {
                if ( options[j].value === val ) {
                    initialSelected.push( options[j].value );
                    break;
                }
            }
        }
    }

    const [ selectedValues, setSelectedValues ] = useState( initialSelected );

    useImperativeHandle(ref, () => ({
        getValue: function () {
            return selectedValues.join(',');
        },
        setValue: function (valString) {
            const values = valString.split(',');
            const newSelected = [];
    
            for ( let i = 0; i < values.length; i++ ) {
                const val = values[i].trim();
    
                for ( let j = 0; j < options.length; j++ ) {
                    if (options[j].value === val) {
                        newSelected.push(options[j].value);
                        break;
                    }
                }
            }
    
            setSelectedValues(newSelected);
        }
    }));
    
    const toggleOption = function( value ) {
        const newSelected = selectedValues.includes(value)
        ? selectedValues.filter(v => v !== value)
        : [...selectedValues, value];

        setSelectedValues( newSelected );

        if (typeof onChange === 'function') {
            onChange( newSelected );
        }
    };

    return (
        <div className={containerClass}>
            {label != null && (
                <label className="multiselect-label">
                    {icon != null && (
                        <span
                            className="multiselect-icon"
                            dangerouslySetInnerHTML={{ __html: icon }}
                        />
                    )}
                    {label}
                </label>
            )}
    
            <div className="multiselect-options">
                {options.map( function ( option ) {
                    const isSelected = selectedValues.includes( option.value );
    
                    return (
                        <div
                            key={name + '-' + option.id}
                            className={'multiselect-option' + (isSelected ? ' selected' : '')}
                            onClick={function () {
                                toggleOption(option.value);
                            }}
                        >
                            {option.icon != null && (
                                <span
                                    className="option-icon"
                                    dangerouslySetInnerHTML={{ __html: option.icon }}
                                />
                            )}

                            { option?.linked_symbol_data?.symbol_type === "Image" &&
                                <div className='option-icon'>
                                    <img 
                                        width={12}
                                        height={12}
                                        src={option?.linked_symbol_data?.symbol_image_url || '#'}
                                        alt={option?.linked_symbol_data?.symbol_name ?? 'symbol'}
                                    />
                                </div>
                            }

                            { option?.linked_gemstone_data &&
                                <div className='option-icon'>
                                    <img 
                                        width={18}
                                        height={18}
                                        src={option?.linked_gemstone_data?.gemstone_image_url || '#'}
                                        alt={option?.linked_symbol_data?.gemstone_name ?? 'gemstone'}
                                    />
                                </div>
                            }

                            { option?.linked_symbol_data?.symbol_type === "Text" &&
                                <span className="option-icon">{option?.linked_symbol_data?.symbol_string}</span>
                            }

                            <span className="option-value">{option.value}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default React.forwardRef( MultiSelect );